import './EditableRichTextField.scss'

import React, { PureComponent } from 'react'
import { Editor, EditorState, ContentState, Modifier } from 'draft-js'
import classNames from 'classnames'
import PropTypes from 'prop-types'

class EditableRichTextField extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false
    }
  }

  getCurrentTextLength = () => {
    return this.props.editorState.getCurrentContent().getPlainText().length
  }

  beforeInput = (chars) => {
    if (this.props.maxLength
      && chars
      && chars.length
      && this.getCurrentTextLength() + chars.length > this.props.maxLength) {
      return 'handled'
    }
  }

  handlePastedText = (text) => {
    let currentLength = this.getCurrentTextLength()
    if (!this.props.maxLength || text.length + currentLength <= this.props.maxLength) {
      return false
    }

    if (currentLength === this.props.maxLength) {
      return true
    }

    const editorState = this.props.editorState
    const newContentState = Modifier.insertText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      text.slice(0, this.props.maxLength - currentLength)
    )
    const es = EditorState.push(editorState, newContentState, 'insert-fragment')
    this.onChange(es)
    return true
  }

  onChange = (editorState) => {
    this.props.onChange(editorState)
  }

  onFocus = () => this.setState({ hasFocus: true })

  onBlur = () => this.setState({ hasFocus: false })

  render() {
    let editorClasses = classNames({
      editableRichTextField: true,
      'editableRichTextField--focused': this.state.hasFocus
    })

    return <div className={editorClasses}>
      <Editor
        stripPastedStyles
        editorState={this.props.editorState}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        placeholder={this.props.placeHolderText}
        handleBeforeInput={this.beforeInput}
        handlePastedText={this.handlePastedText} />
    </div>
  }
}

EditableRichTextField.propTypes = {
  placeHolderText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  editorState: PropTypes.object.isRequired,
  maxLength: PropTypes.number
}

export default EditableRichTextField



// WEBPACK FOOTER //
// ./src/components/EditableRichTextField/EditableRichTextField.js